import { type AxiosResponse } from 'axios';
import { get, put } from '@utilities';
import { type IUpsertEmailCCListRequest } from './interfaces';

const BASE_URL = 'email-config';

export const fetchAllEmailCCConfigs = async (): Promise<AxiosResponse> => await get(`${BASE_URL}/all`);

export const getEmailCCConfigByName = async (name: string): Promise<AxiosResponse> =>
	await get(`${BASE_URL}/${name}`);

export const upsertEmailCCConfig = async (
	name: string,
	payload: IUpsertEmailCCListRequest
): Promise<AxiosResponse> => await put(`${BASE_URL}/${name}`, payload);

export const autocompleteUserEmail = async (prefix: string): Promise<AxiosResponse> =>
	await get('user/email/autocomplete', { prefix });
